import React                         from 'react';
import { numberLayer }               from 'pu-data/SelectOptions';
import { numberOfLayers as tooltip } from 'pu-data/Tooltips';
import SelectComponent               from './SelectComponent';

const NumberLayer = (props) => {
  const {parameters, name} = props;
  const onChange = e => props.onChangeParameter(props.name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={props.groupName} />
  );
};

NumberLayer.defaultProps = {
  label   : '# of Layers',
  name    : 'number_of_layers',
  options : numberLayer,
  required: true,
};

export default NumberLayer;
